import { render, staticRenderFns } from "./LotInfo.vue?vue&type=template&id=66040a0a&"
import script from "./LotInfo.vue?vue&type=script&lang=js&"
export * from "./LotInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports